import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import Autocomplete from 'bootstrap5-autocomplete';

// Exposed via inlineLanguageLabelFiles (page.setupts / frontend_jsinline.xlf).
const resultLabelSingular =
  (window.TYPO3 &&
    window.TYPO3.lang &&
    window.TYPO3.lang.solr_suggest_result_singular) ||
  'result';
const resultLabelPlural =
  (window.TYPO3 &&
    window.TYPO3.lang &&
    window.TYPO3.lang.solr_suggest_result_plural) ||
  'results';

document.querySelectorAll('.tx-solr-suggest').forEach((suggestField) => {
  const searchForm = suggestField.closest('form');
  const suggestUrl = searchForm.dataset.suggest;
  let requestedValue = '';

  const autocomplete = new Autocomplete(suggestField, {
    server: suggestUrl,
    liveServer: true,
    // The timestamp parameter "t" would need a cHash; the endpoint sends "no-store" anyway.
    noCache: false,
    // The typed term is what gets searched: no suggestion is preselected
    // (Enter would submit it instead of the input) and Enter without a
    // selection falls through to the form.
    autoselectFirst: false,
    ignoreEnter: true,
    // Without this, positioning falls back to plain CSS absolute placement
    // and ends up anchored to the wrong ancestor on this page's layout.
    fixed: true,
    // Custom class instead of the default bg-primary/text-white, which
    // clashed with Bootstrap's and the navbar's own hover styles (see
    // _solr.scss).
    activeClasses: ['tx-solr-suggest-active'],
    // Shared with the search action via plugin.tx_solr.view.pluginNamespace.
    queryParam: 'tx_solr[queryString]',
    highlightTyped: true,
    onBeforeFetch: (inst) => {
      requestedValue = inst.getInput().value;
    },
    onServerResponse: (response, inst) =>
      response.json().then((json) => {
        // The debounced fetch still fires after the field was emptied or
        // typed on; for an empty query the server answers with its top
        // terms, which the library would show unfiltered.
        const currentValue = inst.getInput().value;
        if (currentValue === '' || currentValue !== requestedValue) {
          return [];
        }
        const suggestions = json.suggestions || {};
        // value/label stay the plain term - the library fills the input
        // from item.label on selection, so the count must live elsewhere
        // (onRenderItem below) to avoid submitting "term (count)".
        return Object.entries(suggestions).map(([term, count]) => ({
          value: term,
          label: term,
          count,
        }));
      }),
    // Appends the count for display only, without touching label/value.
    onRenderItem: (item, label) => {
      const resultLabel =
        item.count === 1 ? resultLabelSingular : resultLabelPlural;
      return `${label} (${item.count} ${resultLabel})`;
    },
    onSelectItem: () => {
      searchForm.submit();
    },
  });

  // A selection made by arrow key or hover survives further typing in the
  // library, so Enter would submit the stale suggestion.
  suggestField.addEventListener('input', () => {
    autocomplete.removeSelection();
  });
});

$('#tx-solr-search-functions')
  .find('input[type="checkbox"]')
  .change((e) => {
    $(e.target).closest('form').submit();
  });

// Expand all hierarchy facets by default
$('.facet-type-hierarchy.panel-collapse').each(function () {
  $(this).show();
});
